import { render } from "./BlueprintsSection.vue?vue&type=template&id=70eae6b4&scoped=true"
import script from "./BlueprintsSection.vue?vue&type=script&lang=js"
export * from "./BlueprintsSection.vue?vue&type=script&lang=js"

import "./BlueprintsSection.vue?vue&type=style&index=0&id=70eae6b4&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70eae6b4"]])

export default __exports__